export const LOADER = 'LOADER'
export const SELECT_TAB = 'SELECT_TAB'